"use strict";

var _interopRequireDefault = require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/sophiechou/Desktop/whenyoung/\u5609\u5584\u51CF\u707E\u793E\u533A/admin-web/node_modules/.pnpm/@babel+runtime@7.21.0/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _AxiosApi = _interopRequireDefault(require("./AxiosApi.js"));
var apiList = {
  allTree: {
    method: "GET",
    url: "/departmentInfo/tree"
  },
  adminTree: {
    method: "GET",
    url: "/departmentInfo/admin/tree"
  },
  save: {
    method: "POST",
    url: "/departmentInfo"
  },
  update: {
    method: "PUT",
    url: "/departmentInfo"
  },
  delete: {
    method: "DELETE",
    url: "/departmentInfo"
  },
  preview: {
    method: "POST",
    url: "/departmentInfo/preview"
  },
  export: {
    method: "POST",
    url: "/departmentInfo/export"
  },
  import: {
    method: "POST",
    url: "/departmentInfo/import"
  },
  searchList: {
    method: "GET",
    url: "/departmentInfo/searchList",
    meta: {
      "Content-Type": "application/x-www-form-urlencoded"
    }
  }
};
var _default = {
  allTree: function allTree(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.allTree), {}, {
      data: data
    }));
  },
  adminTree: function adminTree(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.adminTree), {}, {
      data: data
    }));
  },
  save: function save(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.save), {}, {
      data: data
    }));
  },
  update: function update(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.update), {}, {
      data: data
    }));
  },
  delete: function _delete(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.delete), {}, {
      data: data
    }));
  },
  preview: function preview(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.preview), {}, {
      data: data
    }));
  },
  export: function _export(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.export), {}, {
      responseType: "blob",
      data: data
    }));
  },
  import: function _import(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.import), {}, {
      data: data
    }));
  },
  searchList: function searchList(data) {
    return (0, _AxiosApi.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, apiList.searchList), {}, {
      data: data
    }));
  },
  checkMapJsonExit: function checkMapJsonExit(data) {
    return (0, _AxiosApi.default)({
      method: "POST",
      url: "/departmentInfo/checkMapJsonExit",
      data: data
    });
  }
};
exports.default = _default;